<section>
  <div class="form-register">
    <form [formGroup]="formTransferConstructionSiteDetail">
      <div class="row ps-1 mb-1">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-input-text class="border-radius-right" [disabled]="true" [labelText]="'Artículo'"
            [value]="codeNameArticle" [required]="true">
          </app-custom-input-text>
        </div>
        @if (accessCostCenterPrice){
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal [labelText]="'Vr. Base'" [disabled]="true" [value]="baseUnitValue">
          </app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal [labelText]="'%Dscto'" [disabled]="true" [value]="rateDiscount">
          </app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal [labelText]="'Vr. Ciente Destino'" [disabled]="true"
            [value]="unitValueClient"></app-custom-input-decimal>
        </div>
        }
        <div class="col-lg-1 col-md-2 col-sm-6 col-6">
          <app-custom-input-text [disabled]="true" [labelText]="'Bodega'" [value]="codeStore">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal [labelText]="'Existencia'" [disabled]="true" [value]="stock">
          </app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-number formControlName="quantity" [labelText]="'Cantidad'"
            [required]="true"></app-custom-input-number>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 col-12 d-flex">
          <div class="d-flex justify-content-end align-items-end gap-2">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [variant]="undefined"
              [disabled]="disableButtonSave" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>